import { AnalyticsTrackingEvent } from '../analytics/events';
import { BaseComponentPropsType } from '../BrandclubLanding/type';
import { TrackingParams } from '../types/AnalyticsTracking';

export const buildTrackingParams = ({
  trackingParams,
  mainEntity,
}: {
  trackingParams: TrackingParams;
  mainEntity: BaseComponentPropsType['mainEntity'];
}) => {
  const queryParams: typeof trackingParams & Record<string, any> = {
    ...(trackingParams || {}),
  };

  if (mainEntity?.type === 'product') {
    queryParams.sku = mainEntity?.entity.stacklineSku;
    queryParams.stacklineSku = mainEntity?.entity.stacklineSku;
    queryParams.retailerId = mainEntity?.entity.retailerId;
    queryParams.retailerSku = mainEntity?.entity.retailerSku;
    queryParams.brandId = mainEntity?.entity.brandId;
  } else if (mainEntity?.type === 'brand') {
    queryParams.brandId = mainEntity?.id?.toString();
  }

  return queryParams;
};

export const trackRetailerProductPageEvent = ({
  trackingEventAction,
  trackingParams,
  analyticsTrack,
}: {
  trackingEventAction: string;
  trackingParams: BaseComponentPropsType['trackingParams'] & Record<string, unknown>;
  analyticsTrack: BaseComponentPropsType['analyticsTrack'];
}) => {
  if (analyticsTrack) {
    window?.dispatchEvent?.(
      new CustomEvent('bc-track', {
        bubbles: true,
        detail: {
          eventName: trackingEventAction,
          ...trackingParams,
        },
      }),
    );

    const eventIndex = ['addToCart', 'openRetailerProductPage', 'navigateToRetailerProductPage'].indexOf(
      trackingEventAction,
    );
    const eventToPublish = [
      AnalyticsTrackingEvent.WEB_APP_ORGANIC_ADD_TO_CART,
      AnalyticsTrackingEvent.WEB_APP_ORGANIC_OPEN_RETAILER_PRODUCT_PAGE,
      AnalyticsTrackingEvent.WEB_APP_ORGANIC_OPEN_RETAILER_PRODUCT_PAGE, // use same event for navigateToRetailerProductPage
    ][eventIndex];
    if (eventToPublish) {
      analyticsTrack(eventToPublish, {
        ...trackingParams,
      });
    } else {
      console.error(`Event not configured for sending to analytics: ${trackingEventAction}`);
    }
  }
};
